export default __webpack_public_path__ + "media/DocumentManagement.42efc4d0fae971598700e00947444452.svg";